<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-btn x-large class="myYellow2 ml-8" to="/">
          <v-icon left>mdi-chevron-left</v-icon> HOME
        </v-btn>
      </v-col>
    </v-row>
    <v-card class="ma-8 pb-2">
      <v-breadcrumbs :items="breadcrumbs">
        <template v-slot:divider>
          <v-icon>mdi-chevron-right</v-icon>
        </template>
      </v-breadcrumbs>

      <v-card class="ma-6 pa-4 d-flex justify-center">
        <v-card width="700" elevation="0" class="transparent">
          <div class="text-h6">
            Order Detail
          </div>

          <v-divider class="my-2"></v-divider>

          <v-row>
            <v-col cols="12" v-for="item in cart" :key="item.id">
              <v-card class="pa-2 d-flex justify-space-between">
                <div class="font-weight-medium">
                  <div>{{ item.title }}</div>
                  <div>
                    {{
                      parseRupiah(
                        item.price * item.quantity -
                          (item.price * item.quantity * item.menu_discount) /
                            100
                      )
                    }},-
                  </div>
                </div>
                <v-card-actions class="d-flex justify-start mr-3">
                  <div class="d-flex justify-center text-center">
                    <v-btn
                      elevation="0"
                      fab
                      x-small
                      icon
                      @click="REDUCE_QUANTITY(item.id)"
                    >
                      <v-icon>mdi-minus</v-icon>
                    </v-btn>
                    <div class="d-flex justify-center align-center mx-1">
                      {{ item.quantity }}
                    </div>
                    <v-btn
                      elevation="0"
                      fab
                      x-small
                      icon
                      @click="ADD_QUANTITY(item.id)"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </div>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-card>

      <v-card class="ma-6 pa-4 d-flex justify-center">
        <v-card width="700" elevation="0" class="transparent">
          <div class="text-h6">
            Payment Method
          </div>

          <v-divider class="my-2"></v-divider>

          <v-container class="mt-2 d-flex justify-center" v-if="choose">
            <v-card
              v-if="paymentId === 1"
              class="d-flex justify-space-between"
              :width="$vuetify.breakpoint.xs ? 320 : 380"
            >
              <v-container>
                <v-img :src="items[0].src" width="80" height="80"></v-img>
              </v-container>
              <v-container
                class="d-flex align-center justify-center flex-column"
              >
                <h5>Unique Code</h5>
                <h5>&#60; Rp. 100 ,-</h5>
              </v-container>
            </v-card>
            <v-card
              v-else-if="paymentId === 2"
              class="d-flex justify-space-between"
              :width="$vuetify.breakpoint.xs ? 320 : 380"
            >
              <v-container>
                <v-img :src="items[1].src" width="80" height="80"></v-img>
              </v-container>
              <v-container
                class="d-flex align-center justify-center flex-column"
              >
                <h5>Platform Fee</h5>
                <h5>Rp. 500,-</h5>
              </v-container>
            </v-card>
            <v-card
              v-else-if="paymentId === 3"
              class="d-flex justify-space-between"
              :width="$vuetify.breakpoint.xs ? 320 : 380"
            >
              <v-container>
                <v-img :src="items[2].src" width="80" height="80"></v-img>
              </v-container>
              <v-container
                class="d-flex align-center justify-center flex-column"
              >
                <h5>Platform Fee</h5>
                <h5>Free</h5>
              </v-container>
            </v-card>
            <v-card
              v-else-if="paymentId === 4"
              class="d-flex justify-space-between"
              :width="$vuetify.breakpoint.xs ? 320 : 380"
            >
              <v-container>
                <v-img :src="items[3].src" width="80" height="80"></v-img>
              </v-container>
              <v-container
                class="d-flex align-center justify-center flex-column"
              >
                <h5>Platform Fee</h5>
                <h5>Free</h5>
              </v-container>
            </v-card>
          </v-container>

          <!-- MODAL  -->

          <v-dialog v-model="dialog" max-width="325">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                width="100%"
                class="mt-4 white--text font-weight-bold"
                outlined
                color="myGreen"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon left>mdi-cash-multiple</v-icon>
                Select Payment Method
              </v-btn>
            </template>

            <!-- TEMPLATE MODAL  -->
            <v-card>
              <v-card
                :width="$vuetify.breakpoint.xs ? 320 : 600"
                :max-height="$vuetify.breakpoint.xs ? 600 : 400"
                class="mx-auto pa-2"
                elevation="0"
              >
                <v-item-group mandatory>
                  <v-card elevation="0">
                    <v-row>
                      <v-col v-for="(item, id) in items" :key="id">
                        <v-item v-slot="{ active, toggle }">
                          <v-card
                            class="d-flex justify-center align-center"
                            :color="active ? 'myGreen' : 'myBrown'"
                            @click="
                              () => {
                                toggle();
                                getPaymentId(id);
                              }
                            "
                          >
                            <v-img
                              :src="item.src"
                              height="120"
                              width="120"
                              class="text-right ma-2"
                            >
                            </v-img>
                          </v-card>
                        </v-item>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-item-group>
              </v-card>

              <v-divider class="mt-4"></v-divider>

              <v-card-actions>
                <v-container class="d-flex justify-center">
                  <v-btn color="primary" @click="chooseMethod()">
                    Choose
                  </v-btn>
                </v-container>
              </v-card-actions>
            </v-card>

            <!-- TEMPLATE MODAL END -->
          </v-dialog>
        </v-card>
      </v-card>

      <v-card class="ma-6 pa-4 d-flex justify-center">
        <v-card width="700" elevation="0" class="transparent">
          <div class="text-h6 font-weight-bold">
            Order Summary
          </div>
          <v-divider class="my-2"></v-divider>
          <div class="d-flex justify-space-between mb-1">
            <h4 class="font-weight-regular">Price</h4>
            <h4 class="font-weight-regular">
              {{ parseRupiah(currentPrice) }},-
            </h4>
          </div>
          <div
            class="d-flex justify-space-between mb-1"
            v-if="paymentMethod.length"
          >
            <h4 class="font-weight-regular">Platform Fee</h4>
            <h4 class="font-weight-regular">
              {{ parseRupiah(paymentMethod[0].transaction_fee) }}
            </h4>
          </div>
          <div class="d-flex justify-space-between mb-1">
            <h4 class="font-weight-regular">Discount</h4>
            <h4 class="font-weight-regular">
              {{ parseRupiah(discountPrice) }}
            </h4>
          </div>
          <v-divider class="mt-3"></v-divider>
          <div class="d-flex justify-space-between mt-4">
            <h3 class="font-weight-bold">TOTAL ({{ totalQuantity }})</h3>
            <h3 class="font-weight-bold" v-if="paymentMethod.length">
              {{
                parseRupiah(
                  currentPrice +
                    paymentMethod[0].transaction_fee -
                    discountPrice
                )
              }},-
            </h3>
          </div>
        </v-card>
      </v-card>

      <v-card class="ma-6 pa-6 d-flex justify-space-between">
        <v-btn text class="myGreen--text" to="/newmenu"
          ><v-icon left>mdi-chevron-left</v-icon> Back</v-btn
        >
        <v-btn class="myGreen white--text" @click="ADD_CHECKOUT">
          Next <v-icon right>mdi-chevron-right</v-icon>
        </v-btn>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Images1 from "../assets/paymentlogo/BCA-payment.png";
import Images2 from "../assets/paymentlogo/QRIS-payment.png";
import Images3 from "../assets/paymentlogo/DIKASIR-payment.png";
import Images4 from "../assets/paymentlogo/DEBIT-payment.png";

export default {
  data: () => ({
    breadcrumbs: [
      {
        text: "Form",
        disabled: false,
        href: "/neworder",
      },
      {
        text: "Menu",
        disabled: false,
        href: "/newmenu",
      },
      {
        text: "Payment Method",
        disabled: false,
        href: "/newcart",
      },
      {
        text: "Done",
        disabled: true,
        href: "/",
      },
    ],
    dialog: false,
    items: [
      { src: Images1, id: 1 },
      { src: Images2, id: 2 },
      { src: Images3, id: 3 },
      { src: Images4, id: 4 },
    ],
    paymentId: null,
    choose: false,
  }),
  methods: {
    ...mapActions([
      "ADD_QUANTITY",
      "REDUCE_QUANTITY",
      "GET_PAYMENT_METHOD",
      "SELECT_PAYMENT_METHOD",
      "ADD_CHECKOUT",
    ]),

    parseRupiah(price) {
      if (price == null) {
        return "";
      } else {
        return (
          "Rp. " +
          price.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1.")
        );
      }
    },
    notesHandler(item) {
      item.isActive = !item.isActive;
    },
    chooseMethod() {
      this.dialog = false;
      this.choose = true;
      this.SELECT_PAYMENT_METHOD(this.paymentId);
    },
    getPaymentId(id) {
      this.paymentId = id + 1;
    },
  },
  computed: {
    ...mapGetters(["cart", "paymentMethod"]),

    totalQuantity() {
      return this.cart.reduce((a, b) => a + b.quantity, 0);
    },
    currentPrice() {
      return this.cart.reduce((a, b) => a + b.quantity * b.price, 0);
    },
    discountPrice() {
      return this.cart.reduce(
        (a, b) => a + (b.price * b.quantity * b.menu_discount) / 100,
        0
      );
    },
  },
  created() {
    this.GET_PAYMENT_METHOD();
  },
  mounted() {
    this.GET_PAYMENT_METHOD();
  },
};
</script>
